import { isRejectedWithValue } from "@reduxjs/toolkit";
import type { MiddlewareAPI, Middleware } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "../slices/snackbar";
import { getApiErrorMessages } from "./apiErrorMessages";

const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => next => action => {
    if (isRejectedWithValue(action)) {
      const endpointName = (action as any).meta?.arg?.endpointName;
      if (endpointName !== "login") {
        getApiErrorMessages((action as any).payload).forEach(message => {
          api.dispatch(
            enqueueSnackbar({
              message,
              options: { variant: "error" },
            }),
          );
        });
      }
    }

    return next(action);
  };

export default rtkQueryErrorLogger;
